import { ConfigFieldsExport } from "hooks/useExportExcel";
import { ConfigFieldImport } from "pages/Components/ImportButton/ImportButton.types";
import { LeaveType, Status } from "services";
import i18n from "translations/i18n";

export const DIALOG_KEY = "LeaveTypeDialog";
export const ExportItemsConfigs: ConfigFieldsExport = {
  code: {
    name: i18n.t("code"),
    order: 1,
  },
  name: {
    name: i18n.t("name"),
    order: 2,
    formatter(row: LeaveType) {
      return [row?.description, row?.nativeDescription]
        ?.filter(Boolean)
        ?.join(" / ");
    },
  },
  description: {
    name: i18n.t("description"),
    order: 3,
  },
  unpaidLeave: {
    name: i18n.t("unpaidLeave"),
    order: 4,
    formatter(row: LeaveType) {
      return row.unpaidLeave
        ? i18n.t("unpaidLeaveType")
        : i18n.t("paidLeaveType");
    },
  },
  status: {
    name: i18n.t("status"),
    order: 5,
    formatter(row: LeaveType) {
      return row.status === Status.Active
        ? i18n.t("active")
        : i18n.t("inactive");
    },
  },
};

export const ImportItemsConfigs: ConfigFieldImport[] = [
  {
    text: i18n.t("code"),
    type: "text",
    field: "code",
    width: 100,
    defaultText: "ANL",
    required: true,
  },
  {
    text: i18n.t("name"),
    type: "text",
    field: "name",
    defaultText: "Annual",
    required: true,
  },
  {
    text: `${i18n.t("name")} (Native)`,
    type: "text",
    field: "nativeName",
    defaultText: "Nghỉ phép năm",
  },
  {
    text: i18n.t("description"),
    type: "text",
    field: "description",
    defaultText: "Nghỉ phép năm",
    required: true,
  },
  {
    text: `${i18n.t("description")} (Native)`,
    type: "text",
    field: "nativeDescription",
    defaultText: "Annual detail",
  },
  {
    text: i18n.t("unpaidLeave"),
    type: "text",
    field: "unpaidLeave",
    defaultText: "unpaid / paid",
    regex: /^(unpaid|paid)$/,
    required: true,
  },
  {
    text: i18n.t("status"),
    type: "text",
    field: "status",
    defaultText: "true / false",
    regex: /^(true|false)$/,
    required: true,
  },
];
